import React, { useState, useEffect, use } from "react";

const FooterButton = (props) => {
    const { icon, title, action, target } = props;
    return (
        <div className="ml-1 my-2 cursor-pointer  d-flex align-items-center" onClick={action} data-toggle="modal" data-target={target}>
            <span className="material-symbols-outlined">
                {icon}
            </span>
            <h6 className="mb-0 ms-2 mx-1 text-light">{title}</h6>
        </div>
    );
};
export default FooterButton;